import "@fontsource/source-sans-pro/latin-400.css";
import "@fontsource/source-sans-pro/latin-600.css";
import "@fontsource/source-sans-pro/latin-700.css";
import "@fontsource/source-sans-pro/latin-400-italic.css";
import "@fontsource/source-sans-pro/latin-600-italic.css";
import "@fontsource/source-sans-pro/latin-700-italic.css";

import '../assets/main.css';

import { initUpdatedContentIslands } from "@/utils/init-updated";
import { initFetcher } from '@/utils/fetcher-raw';
import { initLazyEvent } from '@/utils/lazy-init';
import initFEaaS from '@components/FEaaSWrapper';
import initFormControls from '@components/FormControls/initFormControls';
import initHeadlessExperienceAccelerator from '@sitecorecomponents/HeadlessExperienceAccelerator';

import initAnalytics from '@sitecorecomponents/Analytics';
import initBasicContent from '@sitecorecomponents/BasicContent';
import initNavigation from '@sitecorecomponents/Navigation';
import initUsers from '@sitecorecomponents/Users';
import initRealEstate from '@sitecorecomponents/RealEstate';
import initSearch from '@sitecorecomponents/Search';

initUpdatedContentIslands();
initFetcher();
initLazyEvent();
initFEaaS();
initFormControls();
initHeadlessExperienceAccelerator();

initAnalytics();
initBasicContent();
initNavigation();
initUsers();
initRealEstate();
initSearch();